import { render, staticRenderFns } from "./SalesOrdersPerPerson.vue?vue&type=template&id=29852fb8&"
import script from "./SalesOrdersPerPerson.vue?vue&type=script&lang=js&"
export * from "./SalesOrdersPerPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports